/**
 * Triggers a custom view story event.
 *
 * @param {MouseEvent} event - app menu click event
 * @param {number} index - array index
 * @returns {undefined}
 */
const triggerViewRecord = (event, index) => {
    if (index === 0) {
        return;
    }

    // The item to trigger the view record event for.
    const itemId = event.target.dataset.itemId;

    // No ID? Use native redirect
    if (itemId && itemId.length > 0) {
        event.preventDefault();
        const viewStoryEvent = new CustomEvent('250.view.story', {
            bubbles: true,
            cancelable: false,
            detail: {
                id: itemId
            }
        });
        window.dispatchEvent(viewStoryEvent);
    }
};

export default triggerViewRecord;
